import { getDefaultClient } from '../../factory';
// @endpoint POST /flows
// @controller UserFlow.Query
export async function queryUserFlow(data) {
    return getDefaultClient().post('/flows', data);
}
// @endpoint POST /flows/status
// @controller UserFlow.Status
export async function getUserFlowStatus() {
    return getDefaultClient().post('/flows/status');
}
